import Icon from '../components/Icon.vue'

Icon.register({
  'th-list': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M149.3 216V296C149.3 309.3 138.6 320 125.3 320H24C10.7 320 0 309.3 0 296V216C0 202.7 10.7 192 24 192H125.3C138.6 192 149.3 202.7 149.3 216zM0 376V456C0 469.3 10.7 480 24 480H125.3C138.6 480 149.3 469.3 149.3 456V376C149.3 362.7 138.6 352 125.3 352H24C10.7 352 0 362.7 0 376zM125.3 32H24C10.7 32 0 42.7 0 56V136C0 149.3 10.7 160 24 160H125.3C138.6 160 149.3 149.3 149.3 136V56C149.3 42.7 138.6 32 125.3 32zM205.3 480H488C501.3 480 512 469.3 512 456V376C512 362.7 501.3 352 488 352H205.3C192.1 352 181.3 362.7 181.3 376V456C181.3 469.3 192.1 480 205.3 480zM181.3 56V136C181.3 149.3 192.1 160 205.3 160H488C501.3 160 512 149.3 512 136V56C512 42.7 501.3 32 488 32H205.3C192.1 32 181.3 42.7 181.3 56zM205.3 320H488C501.3 320 512 309.3 512 296V216C512 202.7 501.3 192 488 192H205.3C192.1 192 181.3 202.7 181.3 216V296C181.3 309.3 192.1 320 205.3 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/th-list.js
// module id = rNpU
// module chunks = 144